import React from "react";

import "@styles/c-menuButton.scss";

interface Props {
  onClick: (event: React.MouseEvent) => void;
  icon: React.ReactNode;
  isDesktop?: boolean;
  isDisabled?: boolean;
  isActive?: boolean;
  className?: string;
}

export const MenuButtonComponent: React.SFC<Props> = ({ onClick, icon, isDesktop, isActive, isDisabled, className }) => {

  return (
    <button
      className={`c-menuButton
        ${className || ""}
        ${isDesktop ? "c-menuButton--desktop" : ""}
        ${isActive ? "c-menuButton--active" : ""}
        ${isDisabled ? "c-menuButton--disabled" : ""}`}
      onClick={(event) => {
        if (!isDisabled) {
          onClick(event);
        }
      }}
    >
      {icon}
    </button>
  );
};
